import { httpRequest } from "@services/http";
import { PopulationSegment } from "@models/populationSegment.model";

export interface UpdatePopulationSegmentPayload {
  name?: string;
}

export class CommandUpdatePopulationSegment {
  async run(
    organizationId: number,
    segmentId: number,
    payload: UpdatePopulationSegmentPayload,
  ): Promise<PopulationSegment> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}/segments/${segmentId}/`;
    const response = await httpRequest<any>(url, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
    return PopulationSegment.fromJson(response);
  }
}
